export const transformHttpCustomers = ({ list = [] }) =>
	list.map(name => ({ name }));

export const isEquivalent = (item1 = {}, item2 = {}) =>
	item1.name === item2.name;

export default {
	transformHttpCustomers
};
